import { memo } from 'react';
import CardDataProvider from '../providers/CardDataProvider';
import { useCardContentSections, useCardWrapperSections } from '../hooks/useCardSections';
import { CardWrapper } from './wrappers/CardWrapper';
import styled from 'styled-components';
import { ContentWrapper } from './wrappers/ContentWrapper';
import { CardQuickActions } from './quickActions/CardQuickActions';
import { ExpanderProvider } from './expander/ExpanderProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSection = styled.section.withConfig({
  displayName: "CrmObjectBoardCard__StyledSection",
  componentId: "a1bs0p-0"
})(["&:not(:first-child):not(section:empty){border-top:", " solid ", ";}&:empty + section:not(:empty){border-top:", ";}&:not(:empty) ~ section:empty + section:not(:empty){border-top:", " solid ", ";}a{font-weight:", ";}"], props => props.theme.borderWidth['100'], props => props.theme.color['border-core-subtle'], props => props.theme.borderWidth['0'], props => props.theme.borderWidth['100'], props => props.theme.color['border-core-subtle'], props => props.theme.typography['body-400'].fontWeight);

// We have three types of sections: card_wrapper, card_content, and card_action
// card_wrapper is a section that wraps other sections (e.g. tooltip, title)
// card_content is a section that displays content (e.g. properties)
// card_action is a section that displays action buttons (e.g. preview, meeting)
// card_internal is a section that's not displayed in the content or used in registries (e.g. quick_actions)

const WrapperSections = /*#__PURE__*/memo(({
  children
}) => {
  const cardWrapperSections = useCardWrapperSections();
  const wrapper = cardWrapperSections.reduceRight((wrapperChildren, section) => {
    const {
      Component
    } = section;

    // Important note: Wrapping wrapperChildren with a div is important for tooltip wrapper section
    // Tooltip needs to set data-popover-id attribute on the element
    return /*#__PURE__*/_jsx(Component, {
      children: /*#__PURE__*/_jsx("div", {
        children: wrapperChildren
      })
    });
  }, children);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: wrapper
  });
});
function renderSection(sectionKey, Component, settings) {
  const props = {
    settings,
    key: sectionKey
  };
  return /*#__PURE__*/_jsx(Component, Object.assign({}, props));
}
export const RenderSectionComponent = ({
  sectionKey,
  Component,
  settings
}) => {
  //@bend-expect trellis-tokenized
  return /*#__PURE__*/_jsx(StyledSection, {
    "data-test-id": "crm-object-board-card-section",
    "data-section-key": sectionKey,
    children: renderSection(sectionKey, Component, settings)
  });
};
const ContentSections = /*#__PURE__*/memo(() => {
  const cardContentSections = useCardContentSections();
  const content = cardContentSections.map((section, index) => {
    const {
      settings,
      Component
    } = section;
    return /*#__PURE__*/_jsx(RenderSectionComponent, {
      Component: Component,
      settings: settings,
      sectionKey: section.sectionKey
    }, `${section.sectionKey}-${index}`);
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: content
  });
});
const CrmObjectBoardCard = /*#__PURE__*/memo(({
  cardData
}) => {
  return (
    /*#__PURE__*/
    // Providing cardData to all sections
    _jsx(CardDataProvider, {
      cardData: cardData,
      children: /*#__PURE__*/_jsx(CardWrapper, {
        children: /*#__PURE__*/_jsx(WrapperSections, {
          children: /*#__PURE__*/_jsxs(ExpanderProvider, {
            children: [/*#__PURE__*/_jsx(ContentWrapper, {
              children: /*#__PURE__*/_jsx(ContentSections, {})
            }), /*#__PURE__*/_jsx(CardQuickActions, {})]
          })
        })
      })
    })
  );
});
export { CrmObjectBoardCard };